import { atomWithReset } from "jotai/utils";

import type { AddProductModalState, ProductListItem } from "../types";

export const addProductModalAtom = atomWithReset<AddProductModalState>({
  opened: false
});

export const deleteProductModalAtom = atomWithReset<{
  visible: boolean;
  data: ProductListItem | null;
}>({
  visible: false,
  data: null
});

export const automationModalAtom = atomWithReset<{
  opened: boolean;
  productId: string;
  isAutomationActive: boolean;
}>({
  opened: false,
  productId: "",
  isAutomationActive: false
});

export const changePublishStatusModalAtom = atomWithReset<{
  opened: boolean;
  productId: string;
  currentStatus: string;
  isPublish: boolean;
}>({
  opened: false,
  productId: "",
  currentStatus: "",
  isPublish: false
});

export const setPromoModalAtom = atomWithReset<{
  opened: boolean;
  productId: string;
  isPromoAvailable: boolean;
}>({
  opened: false,
  productId: "",
  isPromoAvailable: false
});

export const platformFeeInputModalAtom = atomWithReset<{
  opened: boolean;
  productSlug: string | null;
}>({
  opened: false,
  productSlug: null
});
